import { Component, OnInit ,Inject, EventEmitter, Input, Output, ElementRef, OnDestroy, OnChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-popup-historyCanotRestore',
  templateUrl: './popup-historyCanotRestore.component.html',
  styleUrls: ['./popup-historyCanotRestore.component.scss'] 
})
export class PopupHistoryCanotRestoreComponent implements OnInit{
  
  constructor(private matDialog:MatDialog) {
    // Bind the methods to preserve 'this' context
   
  }

  ngOnInit() {
    this.detectIOSAndSetupSafeArea();
    this.setupViewportListener();
  }
 
  title = 'לא ניתן לשחזר הזמנה זו';
  subtitle = 'חלק מהפריטים או המרכיבים חסרים כרגע במלאי';
  okButtonText = 'אישור';

  closePopup() {
    this.matDialog.closeAll();
  }
//_______________________
//footer to ios  and android devices
//_______________________


isIOS: boolean = false;
isAndroid: boolean = false;
safeAreaBottom: number = 0;


  private detectIOSAndSetupSafeArea() {
    // Detect iOS
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                 (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    this.isAndroid = /Android/.test(navigator.userAgent);

    if (this.isIOS || this.isAndroid) {
      this.setupSafeArea();
    }
  }

  private setupSafeArea() {
    this.safeAreaBottom = this.getSafeAreaInsetBottom();
    document.documentElement.style.setProperty('--safe-area-bottom', `${this.safeAreaBottom}px`);

    if (this.isIOS) {
      document.body.classList.add('ios-device');
    } else if (this.isAndroid) {
      document.body.classList.add('android-device');
    }
  }

  private getSafeAreaInsetBottom(): number {
    // Try to get safe area from CSS first
    const testElement = document.createElement('div');
    testElement.style.position = 'fixed';
    testElement.style.bottom = '0';
    testElement.style.paddingBottom = 'env(safe-area-inset-bottom)';
    testElement.style.visibility = 'hidden';
    document.body.appendChild(testElement);

    const computedStyle = window.getComputedStyle(testElement);
    const paddingBottom = parseFloat(computedStyle.paddingBottom);

    document.body.removeChild(testElement);

    // Fallback calculation for older iOS or Android with overlays
    if (paddingBottom === 0 && (this.isIOS || this.isAndroid)) {
      return this.calculateBottomSafeArea();
    }

    return paddingBottom;
  }

  private calculateBottomSafeArea(): number {
    const screenHeight = window.screen.height;
    const windowHeight = window.innerHeight;
    const heightDifference = screenHeight - windowHeight;
    // For iOS
    if (this.isIOS) {
      if (heightDifference > 150) return 68; // iPhone X and newer
      

      return 0;
    }
   if (this.isAndroid) {
    // Treat very large differences as browser chrome, not navigation bar
    if (heightDifference > 90 && heightDifference < 300) {
      if (heightDifference < 158) return 50; // Small nav bar
      if (heightDifference < 200) return 80; // Medium nav bar
      if (heightDifference < 250) return 120; // Large nav bar
      return 150; // Very large nav bar
    }
    // If the difference is too large, it's probably browser chrome
    return 0;
  }
  return 0;
}

  private setupViewportListener() {
    let resizeTimer: any;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.updateSafeAreaOnResize();
      }, 100);
    });

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.updateSafeAreaOnResize();
      }, 500);
    });
  }

  private updateSafeAreaOnResize() {
    if (this.isIOS || this.isAndroid) {
      const newSafeAreaBottom = this.getSafeAreaInsetBottom();
      this.safeAreaBottom = newSafeAreaBottom;
      // document.documentElement.style.setProperty('--safe-area-bottom', `${newSafeAreaBottom}px`);
    }
  }

}